import { db } from "@/lib/dexie-db";
import { API_BASE_URL } from "@/lib/api-base";

/**
 * downloadAuthedFile — shared blob-download helper.
 *
 * Liest das Bearer-Token aus IndexedDB (db.auth "current"), fetcht den
 * API-Endpunkt, parst den Content-Disposition-filename und löst einen
 * programmatischen <a>-click aus. ObjectURL wird nach 1 s revoked.
 *
 * @param path        Relativer API-Pfad, z. B. "/v1/rooms/abc/export.pdf?period=all"
 * @param opts.fallbackName  Dateiname wenn Content-Disposition fehlt.
 *
 * @throws Error bei fehlendem Auth-Record oder HTTP-Fehler-Status.
 */
export async function downloadAuthedFile(
  path: string,
  opts?: { fallbackName?: string },
): Promise<void> {
  const authRecord = await db.auth.get("current");
  if (!authRecord) {
    throw new Error("Nicht angemeldet.");
  }

  const url = `${API_BASE_URL}${path}`;
  const resp = await fetch(url, {
    method: "GET",
    headers: { Authorization: `Bearer ${authRecord.accessToken}` },
  });

  if (!resp.ok) {
    throw new Error(`Server-Fehler: ${resp.status}`);
  }

  const blob = await resp.blob();
  const cd = resp.headers.get("Content-Disposition");
  const match = cd?.match(/filename="?([^";]+)"?/);
  const filename = match?.[1] ?? (opts?.fallbackName ?? "download");

  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
}
